"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _component = _interopRequireDefault(require("@loadable/component"));

var _clsx = _interopRequireDefault(require("clsx"));

var _useConvertLinksToRouter = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useConvertLinksToRouter"));

var _ReactList = _interopRequireDefault(require("./ReactList01.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ReactSVGIcon = (0, _component.default)(function () {
  return import("@micado-digital/react-svg-icon/ReactSVGIcon");
});
var Grid = (0, _component.default)(function () {
  return import("@material-ui/core/Grid");
});
var Typography = (0, _component.default)(function () {
  return import("@micado-digital/react-ui/components/Typography");
});

var ReactList01 = function ReactList01(_ref) {
  var data = _ref.data,
      _ref$headlineComponen = _ref.headlineComponent,
      headlineComponent = _ref$headlineComponen === void 0 ? "h2" : _ref$headlineComponen,
      _ref$headlineVariant = _ref.headlineVariant,
      headlineVariant = _ref$headlineVariant === void 0 ? "h2" : _ref$headlineVariant,
      headlineVariants = _ref.headlineVariants,
      icon = _ref.icon,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 1 : _ref$spacing,
      textcontent = _ref.textcontent,
      _ref$textVariant = _ref.textVariant,
      textVariant = _ref$textVariant === void 0 ? "body1" : _ref$textVariant,
      textVariants = _ref.textVariants,
      title = _ref.title,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 0 : _ref$variant;
  var $list = (0, _react.useRef)(null);
  var css = (0, _ReactList.default)();
  (0, _useConvertLinksToRouter.default)($list);
  if (!textcontent && !data && (data === null || data === void 0 ? void 0 : data.length) === 0) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);

  var getGridColumnsByVariant = function getGridColumnsByVariant() {
    switch (variant) {
      case 0:
        return {
          xs: 12,
          sm: 6,
          md: 6
        };

      case 1:
        return {
          xs: 12,
          sm: 12,
          md: 12
        };

      case 2:
        return {
          xs: 12,
          sm: 6,
          md: 4
        };

      default:
        return {
          xs: 12,
          sm: 6,
          md: 6
        };
    }
  };

  var items;

  if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
    items = data === null || data === void 0 ? void 0 : data.map(function (item, counter) {
      return /*#__PURE__*/_react.default.createElement(Grid, {
        className: (0, _clsx.default)("mco-list-01__list-item", css.listItem),
        item: true,
        key: counter,
        xs: getGridColumnsByVariant().xs,
        sm: getGridColumnsByVariant().sm,
        md: getGridColumnsByVariant().md
      }, icon ? icon : /*#__PURE__*/_react.default.createElement(ReactSVGIcon, {
        src: "/img/icons/check.svg",
        color: "primary",
        size: 24
      }), /*#__PURE__*/_react.default.createElement(Typography, {
        component: "p",
        dangerouslySetInnerHTML: {
          __html: item
        },
        variant: textVariant,
        variants: textVariants
      }));
    });
  } else {
    var _textcontent$items;

    items = textcontent === null || textcontent === void 0 ? void 0 : (_textcontent$items = textcontent.items) === null || _textcontent$items === void 0 ? void 0 : _textcontent$items.map(function (item, counter) {
      return /*#__PURE__*/_react.default.createElement(Grid, {
        className: (0, _clsx.default)("mco-list-01__list-item", css.listItem),
        item: true,
        key: counter,
        xs: getGridColumnsByVariant().xs,
        sm: getGridColumnsByVariant().sm,
        md: getGridColumnsByVariant().md
      }, icon ? icon : /*#__PURE__*/_react.default.createElement(ReactSVGIcon, {
        src: "/img/icons/check.svg",
        color: "primary",
        size: 24
      }), /*#__PURE__*/_react.default.createElement(Typography, {
        component: "p",
        dangerouslySetInnerHTML: {
          __html: item.text
        },
        variant: textVariant,
        variants: textVariants
      }));
    });
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-list-01",
    ref: $list
  }, title && /*#__PURE__*/_react.default.createElement(Typography, {
    className: (0, _clsx.default)("mco-list-01__headline", css.headline),
    component: headlineComponent,
    dangerouslySetInnerHTML: {
      __html: title
    },
    variant: headlineVariant,
    variants: headlineVariants
  }), /*#__PURE__*/_react.default.createElement(Grid, {
    className: "mco-list-01__list",
    container: true,
    spacing: spacing
  }, items));
};

ReactList01.propTypes = {
  data: _propTypes.default.array,
  headlineComponent: _propTypes.default.string,
  headlineVariant: _propTypes.default.string,
  headlineVariants: _propTypes.default.object,
  icon: _propTypes.default.object,
  spacing: _propTypes.default.number,
  textcontent: _propTypes.default.object,
  textVariant: _propTypes.default.string,
  textVariants: _propTypes.default.object,
  title: _propTypes.default.string,
  variant: _propTypes.default.number
};
var _default = ReactList01;
exports.default = _default;